import { z } from 'zod';

export const SeedingProposalAcceptResponseSchema = z
  .object({
    orderNo: z.string(),
    orderOptionIds: z.array(z.number()),
    fulfillmentIds: z.array(z.number()),
  })
  .describe('SeedingProposalAcceptResponse');

export type SeedingProposalAcceptResponse = z.infer<typeof SeedingProposalAcceptResponseSchema>;

// 204 No Content — 반환값 없음(빈 본문). 상세 reject 서비스(reject-seeding-proposal)와 동일하게 void.
export const SeedingProposalRejectResponseSchema = z
  .void()
  .describe('SeedingProposalRejectResponse');

export type SeedingProposalRejectResponse = z.infer<typeof SeedingProposalRejectResponseSchema>;
